/**
 * ERP WebView embed (TROC-316 / RWT-7864): persist `?token=` into auth storage
 * before AuthGuard / axios depend on cookie-only TokenRepository.
 * Returns true when a valid query token was absorbed.
 */
export function absorbEmbedAccessToken(options: {
  search?: string;
  getToken: () => string | undefined;
  setToken: (token: string) => void;
  verifyToken: (token: string) => boolean;
  /** When set, removes `token` from the query string after persist. */
  replaceSearch?: (searchIncludingQuestionMarkOrEmpty: string) => void;
}): boolean {
  const rawSearch = options.search ?? (typeof window !== 'undefined' ? window.location.search : '');
  const params = new URLSearchParams(rawSearch.startsWith('?') ? rawSearch.slice(1) : rawSearch);
  const queryToken = (params.get('token') ?? '').trim();
  if (!queryToken) {
    return false;
  }

  if (!options.verifyToken(queryToken)) {
    return false;
  }

  if (options.getToken() !== queryToken) {
    options.setToken(queryToken);
  }

  if (options.replaceSearch) {
    params.delete('token');
    const next = params.toString();
    options.replaceSearch(next ? `?${next}` : '');
  }

  return true;
}
